import React, { useContext } from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import classnames from "classnames";
import Icon from "../icon/Icon";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import { ContactDetailsContext } from "../../context/contact-details-context";
import styles from "./contact-us-product-stock-check-in-store-solution.module.scss";

function ContactUsProductStockCheckInStoreSolution({
  solution: { id, title, fields, buttonType, hierarchyPosition },
  className,
  contactMethods,
}) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.container, className)} data-solution-id={id}>
      <h2 className={styles.top}>Did you know...</h2>
      <h2 className={styles.sub}>There are two ways to get what you need</h2>
      <div className={styles.inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        <div className={styles.content}>
          <div className={classnames(styles.item, styles.itemLeft)}>
            <Icon name="instore" />
            <h6>Check in-store stock</h6>
            <p>You&apos;ll find stock information on most product pages.</p>
            <p>We&apos;ll also let you know if it&apos;s on display in our shop.</p>
          </div>
          <div className={styles.divider}>
            <div className={styles.centerText}>OR</div>
          </div>
          <div className={classnames(styles.item, styles.itemRight)}>
            <Icon name="online" />
            <h6>Buy online and collect in store</h6>
            <p>
              Buy before our <Link href="/delivery-information/click-and-collect">cut-off-window</Link> and collect the
              item tomorrow.
            </p>
            <p>
              If your item&apos;s sold out online, you maybe able to reserve it and collect at your nearest shop. Simply
              check we have three or more in store, then reserve and pay on the phone.
            </p>
          </div>
        </div>
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          className={styles.contactDetails}
          location={locationOnPage}
          contactMethods={contactMethods}
          title={liveChatProminenceExperiment ? "We’re here to help" : "Still need help?"}
          viewContactDetails
          showGreyBackground
        />
      </div>
    </article>
  );
}

ContactUsProductStockCheckInStoreSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    emailUs: PropTypes.arrayOf(PropTypes.string),
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
    partnersLiveChat: PropTypes.arrayOf(PropTypes.string),
  }),
};

ContactUsProductStockCheckInStoreSolution.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsProductStockCheckInStoreSolution;
